export * as emailTransmissions from '@wix/auto_sdk_email-transmissions_email-transmissions/schemas';
